"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERoomsCount = exports.EChartTypes = exports.EChartDatasetId = void 0;
let EChartTypes = /*#__PURE__*/function (EChartTypes) {
  EChartTypes["Default"] = "default";
  EChartTypes["Trends"] = "trends";
  EChartTypes["SupplyDemand"] = "supplyDemand";
  return EChartTypes;
}({});
/* Комнатность дома */
exports.EChartTypes = EChartTypes;
let ERoomsCount = /*#__PURE__*/function (ERoomsCount) {
  ERoomsCount["All"] = "all";
  ERoomsCount["FourPlusRooms"] = "fourPlusRooms";
  ERoomsCount["OneRoom"] = "oneRoom";
  ERoomsCount["Studio"] = "studio";
  ERoomsCount["ThreeRooms"] = "threeRooms";
  ERoomsCount["TwoRooms"] = "twoRooms";
  return ERoomsCount;
}({});
/** В данных должно обязательно присутствовать либо offerPrice либо estimatedPrice, либо оба */
exports.ERoomsCount = ERoomsCount;
let EChartDatasetId = /*#__PURE__*/function (EChartDatasetId) {
  EChartDatasetId["OfferPrice"] = "offerPrice";
  EChartDatasetId["EstimatedPrice"] = "estimatedPrice";
  EChartDatasetId["HouseTrend"] = "houseTrend";
  EChartDatasetId["MarketTrend"] = "marketTrend";
  EChartDatasetId["SupplyTrend"] = "supplyTrend";
  EChartDatasetId["DemandTrend"] = "demandTrend";
  return EChartDatasetId;
}({});
exports.EChartDatasetId = EChartDatasetId;